type UtmContent = 'softpull' | 'stc' | 'vdp';

export default function buildDealershipUrl(
  url: string,
  dealershipId: string | null,
  utmContent?: UtmContent
): string {
  if (!dealershipId) return url;

  const parsed = new URL(url);
  parsed.searchParams.set('utm_source', 'dealership');
  parsed.searchParams.set(
    'utm_campaign',
    `dealership_${dealershipId.replace(/-/g, '_')}`
  );
  if (utmContent) {
    parsed.searchParams.set('utm_content', utmContent);
  }

  return parsed.toString();
}
